import React, { useEffect, useState } from 'react'
import WebMain from './WebMain'
import { useSearchParams, useNavigate } from 'react-router-dom'
import { useBnsXiangMuBanBenLogQuery } from '../store/BnsKeJiApi'
import { Breadcrumb, Button, Divider, Flex, Space } from 'antd'
import { BulbOutlined, ClockCircleOutlined, UserOutlined } from '@ant-design/icons'
function SketchLogs() {
    const navigate = useNavigate()
    const [param] = useSearchParams()
    const bxmbb_id = param.get('bxmbb_id')
    const bxm_id = param.get('bxm_id')
    const bxm_name = param.get('bxm_name')
    const bxmxq_name = param.get('bxmxq_name')
    const bxmbb_name = param.get('bxmbb_name')
    const yh_name = param.get('yh_name')
    const yh_id = param.get('yh_id')
    const {data, isSuccess} = useBnsXiangMuBanBenLogQuery({bxmbb_id:bxmbb_id},{skip:!bxmbb_id})
    const [logs, setLogs] = useState([])
    useEffect(() => {
        if(isSuccess){
            if(data.Status === 'success'){
                setLogs(data.Result)
            }
        }
    }, [isSuccess, data])
    
    return (
        <WebMain>         
            <div style={{width:'100%',display:'flex',justifyContent:'center',flexDirection:'column',alignItems:'center'}}>
                <a onClick={() => {navigate(`/SketchProject?bxm_id=${bxm_id}`)}} style={{textAlign:'center',color:'#fff',fontSize:'28px',fontWeight:'bold'}}>{bxm_name}</a>
                <div style={{minWidth:"1920px",maxWidth:"1920px",display:'flex',justifyContent:'center',gap:'10px'}}>
                    <div style={{
                        backgroundColor:'#fff',
                        padding:'20px',
                        borderRadius:'10px',
                        marginTop:"30px",
                        flex: 1,
                        maxWidth: '1580px'
                    }}>
                        <Flex justify="space-between">
                            <Breadcrumb
                                items={[
                                    {
                                        title: <a onClick={() => {navigate(`/SketchProject?bxm_id=${bxm_id}`)}}>首页</a>
                                    },
                                    {
                                        title: yh_name
                                    },
                                    {
                                        title: bxmxq_name
                                    },
                                    {
                                        title: bxmbb_name
                                    },
                                    {
                                        title: '修改日志'
                                    },
                                ]}
                            />
                            <Button type="primary" onClick={() => {navigate(`/SketchClient?yh_id=${yh_id}&yh_name=${yh_name}&bxm_id=${bxm_id}&bxm_name=${bxm_name}`)}}>返回上一级</Button>
                        </Flex>      
                        {logs.map((log) => (    
                            <div key={log.bbl_id} style={{marginTop:"30px"}}>
                                <Space><ClockCircleOutlined /> {log.bbl_ctime} <UserOutlined /> {log.bbl_cname}</Space>
                                <div style={{ textAlign: 'center',marginTop:'20px'}}>
                                    <img 
                                        src={`/api/assets/images/application/${log.bbl_image || log.bbl_name}`} 
                                        alt={log.bbl_name || ''} 
                                        style={{
                                            width: '100%',
                                            maxWidth: '1440px',
                                            height: 'auto',
                                            objectFit: 'cover',
                                            display: 'block',
                                            margin: '0 auto',
                                            boxShadow: '0 4px 12px rgba(0,0,0,0.1)',
                                            border: '2px #000 solid',
                                        }}
                                        onError={(e) => {
                                            e.target.src = '/img/home/logo.png';
                                        }}                       
                                    />
                                    
                                    
                                </div>
                                <Space style={{marginTop:'15px',marginLeft:'50px',fontSize:'18px',lineHeight:'1.6',color:'#000'}}>
                                    <BulbOutlined /><div dangerouslySetInnerHTML={{__html: log.bbl_content}}></div>
                                </Space>
                                <Divider/>
                            </div>
                        ))}
                    </div>
                </div>
            </div>
        </WebMain>
    )
}

export default SketchLogs